import { render } from "./AttendanceLeave.vue?vue&type=template&id=10c17d7e&scoped=true"
import script from "./AttendanceLeave.vue?vue&type=script&lang=js"
export * from "./AttendanceLeave.vue?vue&type=script&lang=js"

import "./AttendanceLeave.vue?vue&type=style&index=0&id=10c17d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c17d7e"]])

export default __exports__